import { render, staticRenderFns } from "./ThemeSwitch.vue?vue&type=template&id=07b8fcf2&"
import script from "./ThemeSwitch.vue?vue&type=script&lang=ts&"
export * from "./ThemeSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports